import {AxiosResponse} from "axios/index";
import $api from "../../../http";
import {Snapshot} from "../../../models/Snapshot";

export function favouriteVideos(page: number): Promise<AxiosResponse<Snapshot[]>> {
    return $api.get<Snapshot[]>(`video/favourite?page=${page}`);
}